var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleNewsGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1687 17.0248V21.9753C20.1687 21.9753 24.8439 21.9689 26.7475 21.9689C25.7166 25.1782 24.1137 26.9258 20.1687 26.9258C16.1763 26.9258 13.0602 23.6012 13.0602 19.5C13.0602 15.3989 16.1763 12.0743 20.1687 12.0743C22.2795 12.0743 23.6428 12.8364 24.8933 13.8987C25.8942 12.8704 25.8106 12.7239 28.3572 10.2535C26.1954 8.2322 23.3222 7 20.1687 7C13.4481 7 8 12.5964 8 19.5C8 26.4035 13.4481 32 20.1687 32C30.2141 32 32.6694 23.0149 31.8554 17.0248H20.1687L20.1687 17.0248Z",
    fill: "white"
  })));
}

export default SvgGoogleNewsGlyph;